<!-- Search Field -->
<div *ngIf="parentId==0 && !favoritesCheckbox && !favoritesFilter && userType == 1" style="padding-left: 10px;">
  <tyl-form-field label=" Search" style="width: calc(100% - 40px)">
    <input matInput type="text" [(ngModel)]="searchString" (keydown.enter)="searchClick()">
    <button mat-icon-button *ngIf="searchString != ''" (click)="clearSearchClick()"
      style="color: gray; padding-left: 0px;" matSuffix>
      <mat-icon>
        <i [ngClass]="'tyl-ico-fa-times'" aria-hidden="true"></i>
      </mat-icon>
    </button>
  </tyl-form-field>

  <button style="background-color: inherit; border: none;" (click)="searchClick()">
    <img src="./assets/images/search normal.png" title="Search" style="width: 25px; height: 25px;" />
  </button>
</div>

<div *ngFor="let menuItem of portals | menuFilter:parentId">
  <!-- If there is only one portal, show a button -->
  <div *ngIf="menuItem.ParentId == 0 && menuItem.PortalDescription != '' && !favoritesCheckbox && !favoritesFilter"
    class="mat-expansion-panel">
    <button mat-button [id]="'btn-'+ menuItem.GroupName + '-' + menuItem.PortalName" class="pseudoHeader"
      [disabled]="menuItem.Disabled" (click)="!menuItem.Disabled && menuPortalClick(menuItem);">
      <div [innerHTML]="menuItem.PortalName | translate | highlightSearch:searchValue"></div>
    </button>
  </div>

  <div *ngIf="(menuItem.ParentId > 0 && (menuItem.PortalDescription != '' || favoritesFilter))">
    <button mat-menu-item [id]="'btn-'+ menuItem.GroupName + '-' + menuItem.PortalName"
      [ngStyle]="{'display':(favoritesFilter && !menuItem.Selected) ? 'none':''}" [disabled]="menuItem.Disabled"
      (click)="!favoritesCheckbox && menuPortalClick(menuItem);">
      <span *ngIf="favoritesCheckbox">
        <mat-checkbox *ngIf="!favoritesDefaults" [id]="'chk-'+ menuItem.GroupName + '-' + menuItem.PortalName"
          (click)="portalCheckboxClick(menuItem);$event.stopPropagation()" [(ngModel)]="menuItem.Selected">
          {{menuItem.PortalName | translate}}
        </mat-checkbox>
        <mat-checkbox *ngIf="favoritesDefaults" [id]="'chk-'+ menuItem.GroupName + '-' + menuItem.PortalName"
          (click)="portalCheckboxClick(menuItem);$event.stopPropagation()" [(ngModel)]="menuItem.isDefaultSelected">
          {{menuItem.PortalName | translate}}
        </mat-checkbox>
      </span>
      <div [innerHTML]="menuItem.PortalName | translate | highlightSearch:searchValue" *ngIf="!favoritesCheckbox">
      </div>
    </button>
  </div>

  <!-- If there is more than one portal, show an expansion menu -->
  <mat-expansion-panel
    *ngIf="(!favoritesFilter && menuItem.PortalDescription == '') || (favoritesCheckbox && menuItem.ParentId == 0) || (favoritesFilter && showParentGroup(menuItem))"
    [expanded]="menuItem.Expanded == 1" [class.mat-expansion-panel-expanded]="menuItem.Expanded == 1"
    [class.mat-expansion-panel-collapsed]="menuItem.Expanded != 1">
    <mat-expansion-panel-header (click)="savePreferences(menuItem); $event.stopPropagation();"
      [attr.tylerastid]="'pnl-'+ menuItem.GroupName" style="height:48px;">
      <mat-panel-title>
        <div [innerHTML]="menuItem.PortalName | translate | highlightSearch:searchValue" style="float:left;"></div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div *ngIf="(favoritesCheckbox || favoritesFilter) && menuItem.ParentId == 0 && menuItem.PortalDescription != ''">
      <button mat-menu-item [id]="'btn-'+ menuItem.GroupName + '-' + menuItem.PortalName" [disabled]="menuItem.Disabled"
        (click)="!favoritesCheckbox && menuPortalClick(menuItem);">
        <mat-checkbox [id]="'chk-'+ menuItem.GroupName + '-' + menuItem.PortalName" *ngIf="favoritesCheckbox"
          (click)="portalCheckboxClick(menuItem);$event.stopPropagation()" [(ngModel)]="menuItem.Selected">
          {{menuItem.PortalName | translate}}
        </mat-checkbox>
        <span *ngIf="!favoritesCheckbox">
          {{menuItem.PortalName | translate}}
        </span>
      </button>
    </div>

    <child-menu [portals]="portals" [portalMenuPreferences]="portalMenuPreferences" [parentId]="menuItem.Id"
      [favoritesFilter]="favoritesFilter" [favoritesCheckbox]="favoritesCheckbox"
      [favoritesDefaults]="favoritesDefaults" [searchValue]="searchValue" (menuClickEvent)="childMenuClick($event)"
      (portalCheckboxClickEvent)="childPortalCheckboxClick($event)"></child-menu>
  </mat-expansion-panel>
</div>